/*
 * @Author: your name
 * @Date: 2022-01-05 18:30:43
 * @LastEditTime: 2022-03-08 15:49:10
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \datacenter\src\router\routes\testEvaluation.js
 */
/**
 * 路由页面配置
 * meta 标签配置
 * @param {String} title 网站标题
 * @param {String} requireAuth 是否需要登录
 *
 **/
const testEvaluation = [
  // {
  //   path: '/testPaperEvaluation',
  //   name: 'testPaperEvaluation',
  //   meta: { title: '考试跟进', requireAuth: false },
  //   component: () => import('@view/testPaperEvaluation')
  // },
  // {
  //   path: '/paperComments',
  //   name: 'paperComments',
  //   meta: { title: '试卷讲评', requireAuth: false },
  //   component: () => import('@view/testPaperEvaluation/paperComments')
  // },
  {
    path: '/checkImg',
    name: 'checkImg',
    meta: {
      title: '试卷图片'
    },
    component: () => import('@view/testPaperEvaluation/examImg.vue')
  }
]
export default testEvaluation
